import styled from "styled-components";

export const Container = styled.section`
  margin-top: 50px;
  margin-bottom: 50px;
`;

export const CartWrapper = styled.div`
  & h2 {
    margin-bottom: 20px;
  }
`;

export const InfoWrapper = styled.div`
  width: 100%;
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin-bottom: 20px;
  @media screen and (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const InfoBox = styled.div`
  width: 100%;
  min-height: 30rem;
  border: 1px solid #ececec;
  border-radius: 10px;
  padding: 20px;
  position: relative;
  background-color: white;
  display: flex;
  flex-direction: column;
  color: black;

  :last-of-type {
    margin-right: 0;
  }

  .title {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ececec;
  }
`;

export const FormInputRow = styled.div`
  width: ${(props) => (props.half ? "50%" : "100%")};
  display: flex;
  display: -webkit-flex;
  display: -ms-flexbox;
  margin-bottom: 1rem;
  align-items: center;

  @media (max-width: 460px) {
    flex-wrap: wrap;
  }
`;

export const FormInputLargeRow = styled.div`
  width: ${(props) => (props.half ? "50%" : "100%")};
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  :last-of-type {
    margin-bottom: 0;
  }

  .form-control {
    width: 70%;
    display: flex;
    height: 30px;
    padding: 0px 20px;
    text-align: center;
    margin-right: 10px;
    margin-bottom: 10px;
    :last-of-type {
      margin-right: 0px;
    }
  }

  .env-policy {
    display: flex;
    align-items: center;

    & label {
      margin-right: 5px;
      cursor: pointer;
    }
    .policy {
      cursor: pointer;
    }
  }

  .custome-checkbox {
    margin: 0 !important;
    & label {
      ::before {
        margin-bottom: 3px;
      }
    }
  }

  & textarea {
    min-height: 120px;
  }

  .btn-md {
    padding: 5px 10px !important;
  }
`;

// span
export const FormInputBasicSpan = styled.span`
  width: ${(props) => (props.large ? "30%" : "15%")} !important;
  min-width: 70px !important;
  font-size: 1rem;
  word-break: keep-all;
  display: flex;
  margin-right: 10px;
  margin-bottom: 10px;
`;

// 100% span
export const FormInputLargeSpan = styled.span`
  width: 100%;
  min-width: 200px !important;
  font-size: 1rem;
  word-break: keep-all;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
  .example {
    background-color: #3bb77e;
    padding: 5px;
    color: #fff;
    font-size: 0.8rem;
  }
`;

// input
export const FormInputBasicInput = styled.input`
  border: 1px solid #ececec;
  height: 40px;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding-left: 20px;
  font-size: 16px;
  width: ${(props) => (props.address ? "50%" : "50%")};
  width: ${(props) => props.full && "100%"};
  margin-right: 1rem;

  :last-child {
    margin: 0;
  }

  :focus {
    background: transparent;
    border-color: #bce3c9;
  }
  @media (max-width: 1199px) {
    width: 100%;
  }
  @media (max-width: 460px) {
    width: 70%;
    :nth-of-type(2) {
      width: 75%;
      margin-left: 0;
    }
  }
`;

// select
export const FormInputBasicSelect = styled.select`
  width: 80%;
  min-width: 80px !important;
  height: 40px;
  padding-left: 10px;
  border-radius: 10px;
  border: 1px solid #ececec;
  margin-right: 1rem;

  @media (max-width: 460px) {
    width: 70%;
  }
`;

export const FormBasicBtn = styled.button`
  width: 50%;
  height: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  padding: 0;
  color: #fff;
  word-break: keep-all;
  border: 1px solid transparent;
  background-color: ${(props) =>
    props.isCheckingTime ? "#ececec" : "#3bb77e"};
  cursor: pointer;
  border-radius: 10px;
  :hover {
    background: #fdc040 !important;
  }
  @media (max-width: 1199px) {
    width: 50%;
  }
  @media (max-width: 460px) {
    font-size: 12px;
  }
`;

// 주소 검색
export const AddressSearch = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 1rem;
  align-items: center;
  & div {
    width: 50%;
  }
  & input {
    height: 40px;
    width: calc(50% - 16px);
    min-width: 65px;
    margin-left: 16px;
    text-align: center;
    padding: 0;
  }
  @media (max-width: 1199px) {
    & div {
      width: 100%;
    }
    & input {
      width: calc(50% - 16px);
    }
  }

  @media (max-width: 460px) {
    & div {
      width: 70%;
    }
    & input {
      width: calc(50% - 16px);
    }
  }
`;

export const FileUploadWrapper = styled.div`
  width: 100%;
  display: flex;
  & input {
    display: none;
  }

  & ul {
    width: 70%;
  }
  & li {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
    margin: 0;
  }

  .delete_file_btn {
    color: red;
    cursor: pointer;
    :hover {
      color: orange;
    }
  }
`;

export const FileUploadLabel = styled.div`
  width: 30%;
  padding: 10px;
  cursor: pointer;
  border: 1px dashed #ececec;
  text-align: center;
  margin-right: 10px;
  @media screen and (max-width: 1200px) {
    width: 50%;
  }
`;

export const CartTableWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  & span {
    text-align: end;
    margin-bottom: 10px;
  }

  & table {
    text-align: center;
    @media screen and (max-width: 767px) {
      display: none;
    }
  }

  & th {
    :nth-of-type(1) {
      width: 10%;
    }
    :nth-of-type(2) {
      /* width: 33%; */
    }
    :nth-of-type(3) {
      width: 10%;
    }
    :nth-of-type(4) {
      width: 15%;
    }
    :nth-of-type(5) {
      width: 15%;
    }
    :nth-of-type(6) {
      width: 10%;
    }
  }

  & td {
    word-break: keep-all;
    :nth-of-type(2) {
      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        word-break: keep-all;
      }
    }
    & img {
      max-width: 50px;
    }
  }

  .btn-primary {
    :hover {
      border-color: #fdc040;
    }
  }

  .btn-danger {
    background-color: #dc3545;
    :hover {
      border-color: #fd7e14;
      background-color: #fd7e14;
    }
  }

  .custome-checkbox .form-check-label::before {
    margin: 0;
  }
`;

export const CartBtnWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;

  & button {
    margin-right: 10px;
    :last-of-type {
      margin-right: 0;
    }
  }
`;

// 모바일 상품
export const CartProductsMobile = styled.div`
  display: none;

  @media (max-width: 767px) {
    width: 100%;
    display: flex;
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ececec;
  }
`;

export const ProductMobileImg = styled.div`
  width: 20%;
  margin-right: 5%;
  & img {
    width: 100%;
  }
`;

export const ProductMobileInfo = styled.div`
  width: 75%;
  display: none;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
  @media screen and (max-width: 767px) {
    display: flex;
  }

  & h6 {
    width: 100%;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
    font-size: 20px;
    :hover {
      color: #3bb77e;
    }
  }
  & span {
    margin-bottom: 10px;
    font-size: 16px;
  }
  & div {
    width: 100%;
    display: flex;
    align-items: center;
    word-break: keep-all;
    & span {
      width: 100%;
      display: flex;
      text-align: start;
    }
  }

  .btn_wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    margin-left: auto;
  }

  @media (max-width: 575px) {
    & h6 {
      font-size: 18px;
    }
    & span {
      font-size: 16px;
    }
    & div {
      & h6 {
        font-size: 16px;
      }
    }
  }
  @media (max-width: 424px) {
    & h6 {
      font-size: 16px;
    }
    & span {
      font-size: 14px;
    }
  }
`;
// 모바일 상품 끝
